import React from 'react';

import { Avatar } from '@splitfiesta/ui';

import { PlaceholderBadge } from '@/components/members/PlaceholderBadge';

import { getInputClasses } from '@/lib/styles/form';

interface Props {
  inputId: string;
  inputTestId: string;
  /** The name the file gave this member, for the accessible label. */
  header: string;
  name: string;
  maxLength: number;
  nameLabel: string;
  meLabel: string;
  isSelf: boolean;
  onChangeName: (name: string) => void;
}

/**
 * One member column of the file: initials avatar, editable name, and a chip
 * saying what the member becomes — you, or a placeholder. Which row is you
 * is chosen outside the list, so the row stays a single line.
 */
export function MemberRow({
  inputId,
  inputTestId,
  header,
  name,
  maxLength,
  nameLabel,
  meLabel,
  isSelf,
  onChangeName,
}: Props) {
  return (
    <div className="flex items-center gap-3 px-4 py-3">
      {/* The header is the fallback so a cleared field keeps its initials. */}
      <Avatar name={name.trim() || header} size="md" className="shrink-0" />
      <div className="min-w-0 flex-1">
        <label htmlFor={inputId} className="sr-only">
          {`${nameLabel}: ${header}`}
        </label>
        <input
          id={inputId}
          data-testid={inputTestId}
          type="text"
          value={name}
          maxLength={maxLength}
          onChange={event => onChangeName(event.target.value)}
          className={getInputClasses()}
        />
      </div>
      {isSelf ? (
        // Same size as the placeholder badge it replaces, so rows line up.
        <span className="shrink-0 rounded-full bg-primary-500 px-2 py-0.5 text-[10px] uppercase tracking-wide text-white">
          {meLabel}
        </span>
      ) : (
        <PlaceholderBadge />
      )}
    </div>
  );
}
